import { render, staticRenderFns } from "./ListNoData.vue?vue&type=template&id=ab519e3c&scoped=true&"
import script from "./ListNoData.vue?vue&type=script&lang=js&"
export * from "./ListNoData.vue?vue&type=script&lang=js&"
import style0 from "./ListNoData.vue?vue&type=style&index=0&id=ab519e3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab519e3c",
  null
  
)

export default component.exports